import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AppDataState } from '@/zustand/interfaces/app-data';

export const useAppData = create<AppDataState, [['zustand/persist', unknown]]>(
  persist(
    (set) => ({
      appData: null,
      setAppData: (appData) =>
        set({
          appData
        }),
      removeAppData: () =>
        set({
          appData: null
        })
    }),
    {
      name: 'appData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
